import React from 'react';
import FilterBox from 'components/filter-box/FilterBox';
import { Button, styled, TextField } from '@mui/material';
import KeyboardDatePicker from 'components/pickers/KeyboardDatePicker';
import { Search } from '@mui/icons-material';
import { useSurgerie } from './hooks/useSurgerie';

const Filter = styled('form')(({ theme }) => ({
  display: 'grid',
  alignItems: 'center',
  columnGap: 10,
  rowGap: 15,
  flex: 1,
  gridTemplateColumns: '1.3fr 0.9fr 0.9fr 0.9fr 200px 100px',
  '& .date-picker': {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: 10,
  },
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: '1fr 1fr 1fr',
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr 1fr',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

const FilterSecondLine = styled('div')(({ theme }) => ({
  display: 'grid',
  alignItems: 'center',
  gridTemplateColumns: '300px 300px 100px',
  columnGap: 10,
  rowGap: 15,
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr 1fr 100px',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

const SurgerieClosedFilterBox: React.FC = () => {
  const { filter, handleChangeFilter, handleSearch, loading } = useSurgerie();

  return (
    <FilterBox>
      <Filter onSubmit={handleSearch}>
        <div className="date-picker">
          <KeyboardDatePicker
            disableFuture
            label="Data inicial"
            value={filter.initial_date}
            onChange={date => handleChangeFilter('initial_date', date)}
          />
          <KeyboardDatePicker
            disableFuture
            label="Data final"
            value={filter.final_date}
            onChange={date => handleChangeFilter('final_date', date)}
          />
        </div>

        <TextField
          label="Médico"
          placeholder="Digite o nome do médico"
          value={filter.doctor_name}
          onChange={e => handleChangeFilter('doctor_name', e.target.value)}
        />

        <TextField
          label="Paciente"
          placeholder="Digite o nome do paciente"
          value={filter.patient_name}
          onChange={e => handleChangeFilter('patient_name', e.target.value)}
        />

        <TextField
          label="Hospital"
          placeholder="Digite o nome do hospital"
          value={filter.hospital_name}
          onChange={e => handleChangeFilter('hospital_name', e.target.value)}
        />

        <TextField
          label="Por operador"
          placeholder="Digite o nome do operador"
          value={filter.closed_by}
          onChange={e => handleChangeFilter('closed_by', e.target.value)}
        />

        <Button
          style={{ maxWidth: 100 }}
          type="submit"
          disabled={loading}
          variant="contained"
          color="primary"
          size="small"
          startIcon={<Search />}
        >
          Buscar
        </Button>
      </Filter>
    </FilterBox>
  );
};

export default SurgerieClosedFilterBox;
